/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import MaterialTable from "@material-table/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEdit,
    faMinusSquare,
    faPlusCircle,
    faPlusSquare, faSearch, faSync,
    faTimesCircle
} from "@fortawesome/free-solid-svg-icons";
import ProductModal from "./ProductModal";
import { ADD_INVENTORY, ADD_PRODUCT, EDIT_PRODUCT, REMOVE_INVENTORY } from "../../../../utils/constants";
import util from "../../../../utils/miniUtils";
import { ThemeProvider, Tooltip } from "@mui/material";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import ModifyInventory from "./ModifyInventory";
import ProductsDetail from "../ProductDetail/ProductsDetail";
import AdvanceFilter from "../AdvanceFilter/AdvanceFilter";
import { Image } from "react-bootstrap";
import { useWindowResize } from "../../../../utils/useWindowResize";
import ExampleApp from "../../../../ExampleApp";
import { read_cookie } from "sfcookies";
import InventoryTable from "../../../InventoryTable/InventoryTable";

export default function ProductEntry () {
    const tableRef = useRef( null );

    const [ACTION, setACTION] = useState( ADD_PRODUCT );
    const [inventoryAction, setInventoryAction] = useState( ADD_INVENTORY );
    const [show, setShow] = useState( false );
    const [showModifyInventory, setShowModifyInventory] = useState( false );
    const [showProductDetail, setShowProductDetail] = useState( false );
    const [showAdvanceFilter, setShowAdvanceFilter] = useState( false );
    const [showAlert, setShowAlert] = useState( {
        delete: false,
        zeroProducts: false,
        duplicate: false
    } );

    const MySwal = withReactContent( Swal );
    const { height } = useWindowResize();
    const [state, setState] = useState( {
        article: "",
        description: "",
        size: "",
        model: "",
        brand: "",
        categoryName: "",
        internal_id: "",
    } );
    // Store the current page, limit, etc...
    const [currentQuery, setCurrentQuery] = useState( {} );
    const [rowData, setRowData] = useState( null );
    const [selectedRows, setSelectedRows] = useState( [] );

    const reloadData = () => {
        // Llamar al método reloadData del InventoryTable para mantener los filtros
        if ( tableRef.current && tableRef.current.reloadData ) {
            tableRef.current.reloadData();
        }
    };
    
    // Función para limpiar la selección de filas
    const clearSelectedRows = () => {
        setSelectedRows( [] );
        if ( tableRef.current && tableRef.current.clearSelection ) {
            tableRef.current.clearSelection();
        }
    };
    
    useEffect( () => {
    }, [] );

    useEffect( () => {
        if ( showAdvanceFilter ){
            tableRef.current && tableRef.current.onQueryChange( { page: 0, search: '' } );
        }
    },[state] );

    const urlHandler = ( query ) => {
        let orderBy = ( query.orderBy && query.orderBy.field !== "undefined" ) ? query.orderBy.field : "id";
        let direction = ( query.orderDirection === "" || query.orderDirection === "undefined" || !query.orderDirection ) ? "desc" : query.orderDirection;
        let search = ( query.search === "" ) ? "" : query.search;
        const { id, article, description, size_id, model_id, brand_id, category_id, year_end, year } = state;
        let q = `article=${article}&description=${description}&id=${id}&size_id=${size_id}&model_id=${model_id}&brand_id=${brand_id}&category_id=${category_id}&year_end=${year_end}&year=${year}`;
        return `product/read?page=${query.page}&rows=${query.pageSize}&orderBy=${orderBy}&direction=${direction}&search=${search}&${q}`;
    };

    const deleteProduct = async () => {
        try {
            const response = await util.axios.post( `product/data/delete/`, { ids: rowData } );
            const { error, msg } = response["data"];
            if ( error ) throw new Error( msg );
            reloadData();
            util.toast().success(  "Productos eliminados" );
        } catch ( e ) {
            util.handleError( e );
        }
    };

    

    // Función para mostrar alerta de productos sin stock
    useEffect( () => {
        if ( showAlert.zeroProducts ) {
            MySwal.fire( {
                icon: 'warning',
                title: 'Seleccione solo productos con piezas disponibles',
                text: 'Hay productos seleccionados con 0 piezas.',
                confirmButtonText: 'Ok',
                customClass: { confirmButton: 'btn btn-warning' },
                buttonsStyling: false
            } ).then( () => {
                setShowAlert( { ...showAlert, zeroProducts: false } );
            } );
        }
    }, [showAlert.zeroProducts] );

    // Función para mostrar alerta de confirmación de borrado
    useEffect( () => {
        if ( showAlert.delete ) {
            MySwal.fire( {
                icon: 'warning',
                title: 'Esta seguro?',
                text: 'Esta acción no se puede deshacer',
                showCancelButton: true,
                confirmButtonText: 'Eliminar este producto',
                cancelButtonText: 'Cancelar',
                customClass: {
                    confirmButton: 'btn btn-danger',
                    cancelButton: 'btn btn-secondary'
                },
                buttonsStyling: false
            } ).then( ( result ) => {
                setShowAlert( { ...showAlert, delete: false } );
                if ( result.isConfirmed ) {
                    deleteProduct();
                }
            } );
        }
    }, [showAlert.delete] );
    
    const handleRowAction = ( action, item ) => {
        if ( action === 'view' ) {
            setRowData( item );
            setShowProductDetail( true );
        } else if ( action === 'edit' ) {
            setACTION( EDIT_PRODUCT );
            setRowData( item );
            setShow( true );
        }
    };
    
    const handleAction = ( action, selectedIds ) => {
        // Convertir selectedIds a objetos completos para compatibilidad
        const selectedProducts = selectedIds;
        
        switch ( action ) {
            case 'bulkActivate':
                setSelectedRows( selectedProducts );
                setInventoryAction( ADD_INVENTORY );
                setShowModifyInventory( true );
                break;
            case 'bulkDeactivate':
                // Verificar que los productos tengan stock antes de dar de baja
                // Para simplicidad, asumimos que la validación se hace en ModifyInventory
                setSelectedRows( selectedProducts );
                setInventoryAction( REMOVE_INVENTORY );
                setShowModifyInventory( true );
                break;
            case 'bulkDelete':
                setRowData( selectedProducts );
                setShowAlert( { ...showAlert, delete: true } );
                break;
            default:
                break;
        }
    };
    
    const handleError = ( error ) => {
        console.error( 'Error en InventoryTable:', error );
    };
    
    const handleCreateProduct = () => {
        setACTION( ADD_PRODUCT );
        setShow( true );
    };
    
    const authToken = read_cookie( "inventory-tkn" );
    
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    {/* <h2 className="mb-4">Inventario de Productos</h2> */}
                    {/* Componente InventoryTable */}
                    <InventoryTable
                        ref={tableRef}
                        authToken={authToken}
                        baseUrl={process.env.REACT_APP_BASE_URL}
                        onRowAction={handleRowAction}
                        onAction={handleAction}
                        onError={handleError}
                        onCreateProduct={handleCreateProduct}
                    />
                </div>
            </div>

            {/* Modales */}
            {show ?
                <ProductModal show={show} product_id={rowData?.id} handleClose={() => setShow( false )} action={ACTION}
                    reloadData={reloadData}/> : null}

            {showProductDetail ? <ProductsDetail show={showProductDetail} product_id={rowData?.id}
                handleClose={() => setShowProductDetail( false )}/> : null}

            {showModifyInventory ? <ModifyInventory show={showModifyInventory} inventoryAction={inventoryAction}
                handleClose={() => { setShowModifyInventory( false ); clearSelectedRows(); }}
                products={selectedRows} reloadData={reloadData}/> : null}
        </div>
    );

    // return <ExampleApp />;

}